'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagGiAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M0 0H28V13.3138H0V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V13.3333H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 13.3333H0V20H28V13.3333Z", fill: "#E71924" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 8H10.6667V5.9873C10.6667 5.62008 10.3654 5.33333 9.9938 5.33333H8.67295C8.28542 5.33333 8.00004 5.62613 8.00004 5.9873V10.6667L6.66671 12H21.3334L20 10.6667V5.9873C20 5.62008 19.6988 5.33333 19.3271 5.33333H18.0063C17.6188 5.33333 17.3334 5.62613 17.3334 5.9873V8H16V4.65397C16 4.28674 15.7043 4 15.3395 4H12.6606C12.2877 4 12 4.29279 12 4.65397V8Z",
          fill: "#EA1824"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.33337 10.6667C8.96518 10.6667 8.66671 10.3682 8.66671 10C8.66671 9.63181 8.96518 9.33333 9.33337 9.33333C9.70156 9.33333 10 9.63181 10 10C10 10.3682 9.70156 10.6667 9.33337 10.6667ZM9.33337 8C8.96518 8 8.66671 7.70152 8.66671 7.33333C8.66671 6.96514 8.96518 6.66667 9.33337 6.66667C9.70156 6.66667 10 6.96514 10 7.33333C10 7.70152 9.70156 8 9.33337 8ZM14 10.6667C13.6319 10.6667 13.3334 10.3682 13.3334 10C13.3334 9.63181 13.6319 9.33333 14 9.33333C14.3682 9.33333 14.6667 9.63181 14.6667 10C14.6667 10.3682 14.3682 10.6667 14 10.6667ZM14 6.66667C13.6319 6.66667 13.3334 6.36819 13.3334 6C13.3334 5.63181 13.6319 5.33333 14 5.33333C14.3682 5.33333 14.6667 5.63181 14.6667 6C14.6667 6.36819 14.3682 6.66667 14 6.66667ZM18.6667 10.6667C18.2985 10.6667 18 10.3682 18 10C18 9.63181 18.2985 9.33333 18.6667 9.33333C19.0349 9.33333 19.3334 9.63181 19.3334 10C19.3334 10.3682 19.0349 10.6667 18.6667 10.6667ZM18.6667 8C18.2985 8 18 7.70152 18 7.33333C18 6.96514 18.2985 6.66667 18.6667 6.66667C19.0349 6.66667 19.3334 6.96514 19.3334 7.33333C19.3334 7.70152 19.0349 8 18.6667 8Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.3334 13.2575V16H12V17.3333H14.6667V13.2575C15.4435 13.0744 16 12.5805 16 12C16 11.2636 15.1046 10.6667 14 10.6667C12.8955 10.6667 12 11.2636 12 12C12 12.5805 12.5566 13.0744 13.3334 13.2575Z",
          fill: "#ECCE3E"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M28 0V13.3138H27.5V0.5H0.5L0.5 13.3138H0V0H28Z", fill: "#949494" })
    ]
  }
);
const VpFlagGiAsset = forwardRef(FlagGiAsset);

export { VpFlagGiAsset as default };
